<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.REMOVE_TAGS_FROM_ORDER.DESCRIPTION' | translate }}
  </div>
  <ng-container>
    <form [formGroup]="form">
      <glxy-checkbox [formControl]="removeAllTagsControl">
        {{ 'AUTOMATIONS.EDITOR.TASKS.REMOVE_TAGS_FROM_ORDER.REMOVE_ALL' | translate }}
      </glxy-checkbox>
      <forms-va-input-tags
        [placeholder]="'AUTOMATIONS.EDITOR.TASKS.REMOVE_TAGS_FROM_ORDER.TAG' | translate"
        [formControl]="tagsControl"
        [allowCustomTags]="true"
        [allowDuplicates]="false"
        [options]="options$ | async"
        [loading]="loadingTagList"
        [ngClass]="{ hidden: !!removeAllTagsControl.value }"
        class="delay-input-fill"
        appearance="outline"
      ></forms-va-input-tags>
    </form>
  </ng-container>
</div>
